(function() {
  var wrapper = document.getElementById('custom-message-wrapper');
  var textarea = document.getElementById('custom-message');
  var charCount = document.getElementById('char-count');

  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.swatch-element');
    if (!swatch) return;
    wrapper.style.display = swatch.classList.contains('custom-printed-message') ? 'block' : 'none';
  });

  textarea.addEventListener('input', function() {
    charCount.textContent = textarea.value.length;
  });

  var preSelected = document.querySelector('.swatch-element.custom-printed-message.active');
  if (preSelected) wrapper.style.display = 'block';
})();
